// A display filter, not a new order/payment status or a payment mutation.
export const UNMARKED_PAYMENT_FILTER = "UNMARKED_PAYMENT";

export const UNMARKED_PAYMENT_SQL = `o.payment_status IN ('UNPAID', 'WAITING_VERIFICATION', 'REJECTED')
  AND o.order_status NOT IN ('CANCELLED', 'REJECTED')`;

export function needsPaymentMark(order: Record<string, unknown>): boolean {
  const payment = order.paymentStatus ?? order.payment_status;
  const status = order.orderStatus ?? order.order_status;
  return (
    ["UNPAID", "WAITING_VERIFICATION", "REJECTED"].includes(String(payment)) &&
    !["CANCELLED", "REJECTED"].includes(String(status))
  );
}
